export default "__VITE_PUBLIC_ASSET__8d663963__"